
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/gamefi",
      function () {
        return require("private-next-pages/solutions/gamefi.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/gamefi"])
      });
    }
  